import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import List from 'components/List';
import BasePeriodSelect from 'components/PeriodSelect';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 40px 16px 16px;
    background: ${ColorPalette.HEX.Lotion};
    min-height: calc(100% - 80px);
  }
`;

export const SubHeader = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const TitleContainer = styled.div``;

export const StyledList = styled(List)`
  width: 100%;
  padding: 0px;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }
`;

export const Title = styled.span`
  width: 100%;
  text-align: left;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.travelWithExpensesList.titleColor};
`;

export const SubTitle = styled.span`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: ${({ theme }) => theme.travelWithExpensesList.subtitleColor};
`;

export const ExpenseCard: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-image: ${({ theme }) => theme.travelWithExpensesList.expenseCardBackground};
  padding: 16px;
  margin: 32px 0 16px 0;
  height: 56px;
  width: 100%;
  border-radius: 12px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 350px;
    margin: 0 0 0 32px;
  }
`;

ExpenseCard.Icon = styled.img`
  width: 12px;
  height: 14px;
  margin-right: 8px;
  object-fit: contain;
`;

ExpenseCard.Info = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
`;

ExpenseCard.InfoTitle = styled.span`
  font-size: 10px;
  line-height: 1.6;
  font-weight: bold;
  color: ${({ theme }) => theme.travelWithExpensesList.expenseCardColor};
`;

ExpenseCard.Date = styled.span`
  font-size: 10px;
  line-height: 1.6;
  font-weight: normal;
  color: ${({ theme }) => theme.travelWithExpensesList.expenseCardColor};
`;

ExpenseCard.Price = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  color: ${({ theme }) => theme.travelWithExpensesList.expenseCardColor};
`;

export const PeriodSelect = styled(BasePeriodSelect)`
  margin-top: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: calc(50% - 8px);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
`;
